import { useCallback, useEffect, useState } from "react";
import WorkTasksService from "../../../services/workTasks";
import { usePrevious } from "../../../lib/hooks/previous";

export const useFetchCount = () => {
  const [total, setTotal] = useState<number>(0);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [request, setRequest] = useState<any>({
    pageNumber: 1,
    pageSize: 50,
    isClosed: false
  });

  const onPageChange = useCallback(
    (pageNumber: number, pageSize = 50) => {
      const newRequest = { ...request, pageNumber, pageSize };

      setRequest(newRequest);
    },
    [request]
  );

  const prevRequest = usePrevious(request);

  const fetchCount = useCallback(
    (showLoader?: boolean) => {
      showLoader && setIsLoading(true);

      WorkTasksService.fetchCount(request)
        .then((res: number) => {
          setTotal(res);

          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
    },
    [request]
  );

  useEffect(() => {
    if (!prevRequest || prevRequest.isClosed !== request.isClosed) {
      fetchCount(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchCount]);

  return { total, isLoading, request, setRequest, fetchCount, onPageChange };
};
